// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__3kxWg","header":"Card_header__1DvOR","img":"Card_img__1fq0_","titulo":"Card_titulo__QjM3i","contenido":"Card_contenido__POrd0"};